export default __webpack_public_path__ + "static/media/track_orders.f061f90a.PNG";